/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-github': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25A8.75 8.75 0 007.231 18.3c.438.081.625-.188.625-.419v-1.487c-2.431.525-2.944-1.175-2.944-1.175A2.319 2.319 0 003.9 13.938c-.794-.538.063-.532.063-.532a1.84 1.84 0 011.337.906 1.875 1.875 0 002.55.726c.035-.444.23-.86.55-1.17-1.938-.224-3.981-.974-3.981-4.324a3.375 3.375 0 01.9-2.35 3.125 3.125 0 01.087-2.313s.732-.237 2.407.894a8.313 8.313 0 014.375 0c1.668-1.131 2.4-.894 2.4-.894.324.731.355 1.56.087 2.313.592.638.914 1.48.9 2.35 0 3.362-2.044 4.1-3.994 4.319.423.428.64 1.018.594 1.618v2.4c0 .288.156.506.625.419A8.75 8.75 0 0010 1.25z"/>'
  }
})
